exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?minimize!../assets/swiper-3.4.0.min.css"), "");

// module
exports.push([module.id, ".banner{max-width:500px;height:148px;position:absolute;top:112px;left:50%;transform:translateX(-50%)}.banner,.banner img,.swiper-container{width:100%}.swiper-pagination-bullets{bottom:20px!important}.swiper-pagination-bullet-active{background:rgba(125,255,125,.5)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-78728a9b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/banner2.vue
// module id = 52
// module chunks = 0